import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { DO_NOT_USE_FaWrapper } from '../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { forwardRef } from 'react';
import { useGeneratedId } from '../../../utils/index.js';
import { Loader } from '../../../loader/index.js';
import { Container, Label, SelectContainer, IconContainer, StyledSelect, Description } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useDescriptionWarning } from './hooks/useDescriptionWarning.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var EMPTY_VALUE = '';
var Select = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var autoId = useGeneratedId('select');
  var iconSize = 16;
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'outline' : _props$variant,
    _props$id = props.id,
    id = _props$id === void 0 ? autoId : _props$id,
    label = props.label,
    ariaDescribedBy = props['aria-describedby'],
    description = props.description,
    _props$stretch = props.stretch,
    stretch = _props$stretch === void 0 ? false : _props$stretch,
    _props$invalid = props.invalid,
    invalid = _props$invalid === void 0 ? false : _props$invalid,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    appearance = props.appearance,
    _props$value = props.value,
    value = _props$value === void 0 ? EMPTY_VALUE : _props$value,
    onChange = props.onChange,
    children = props.children,
    placeholder = props.placeholder,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    loading = props.loading,
    _props$labelSize = props.labelSize,
    labelSize = _props$labelSize === void 0 ? 'small' : _props$labelSize,
    restProps = __rest(props, ["variant", "id", "label", 'aria-describedby', "description", "stretch", "invalid", "disabled", "appearance", "value", "onChange", "children", "placeholder", "size", "loading", "labelSize"]);
  var hasValue = value !== EMPTY_VALUE;
  var hasPlaceholder = Boolean(placeholder);
  var controlledValue = hasPlaceholder && !hasValue ? EMPTY_VALUE : value;
  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event);
    }
  };
  var describedBy = ariaDescribedBy || description && id + "-description";
  useDescriptionWarning({
    ariaDescribedBy: ariaDescribedBy,
    description: description
  });
  var selectProps = Object.assign(Object.assign({}, restProps), {
    ref: forwardedRef,
    id: id,
    disabled: disabled,
    'aria-describedby': describedBy,
    value: controlledValue,
    onChange: handleChange
  });
  var styledSelectProps = {
    $variant: variant,
    $showPlaceholderStyle: hasPlaceholder && !hasValue,
    $size: size,
    $iconSize: iconSize
  };
  return /*#__PURE__*/jsxs(Container, {
    $stretch: stretch,
    children: [label && /*#__PURE__*/jsx(Label, {
      htmlFor: id,
      $invalid: invalid,
      $variant: variant,
      $labelSize: labelSize,
      children: label
    }), /*#__PURE__*/jsxs(SelectContainer, {
      $variant: variant,
      $invalid: invalid,
      $appearance: appearance,
      children: [/*#__PURE__*/jsx(IconContainer, {
        $variant: variant,
        children: loading ? /*#__PURE__*/jsx(Loader, {
          size: 6
        }) : /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
          icon: faChevronDown,
          $size: iconSize
        })
      }), /*#__PURE__*/jsxs(StyledSelect, _extends({}, selectProps, styledSelectProps, {
        "aria-busy": loading,
        children: [hasPlaceholder && /*#__PURE__*/jsx("option", {
          disabled: true,
          hidden: true,
          value: EMPTY_VALUE,
          children: placeholder
        }), children]
      }))]
    }), description && /*#__PURE__*/jsx(Description, {
      $invalid: invalid,
      id: describedBy,
      $disabled: disabled,
      children: description
    })]
  });
});

export { Select };
